export default __webpack_public_path__ + "static/media/New York1.eeab62d7.png";